import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GraphAPITaskUpdateResult  {
    _originalTypeClassName = "ekylikeio.BO.GraphAPITaskUpdateResult";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GraphAPITaskUpdateResult.translate = translateService;
}
this.Success = false;
this.TaskExists = false;
this.GraphAPITaskUpdateResultKey = null;
this._key = this.GraphAPITaskUpdateResultKey = 0; 
}

static translate: TranslateService;
_key: any;
Success:any;
TaskExists:any;
private _GraphAPITaskUpdateResultKey:any;
get GraphAPITaskUpdateResultKey(): any {
    return this._GraphAPITaskUpdateResultKey;
  }
set GraphAPITaskUpdateResultKey(value: any) {
    this._GraphAPITaskUpdateResultKey = value;
    this._key = value;
  }

static CreateFrom(success: any,taskExists: any): any{let res = new Domain.GraphAPITaskUpdateResult();
res.Success = success;
res.TaskExists = taskExists;
return res;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GraphAPITaskUpdateResultKey == null || $this.GraphAPITaskUpdateResultKey == 0;
            }


}